import "./App.css";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routeindex from "./route";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routeindex />
            </BrowserRouter>
        </div>
    );
}

export default App;
